import apiClient from "./ApiInterceptor";

export const fetchUnreadNotifications = async (userId, page = 1, limit = 10) => {
  const res = await apiClient.get(`/notifications/unread/${userId}?page=${page}&limit=${limit}`);
  return res.data;
};

export const fetchRecentNotifications = async (userId, page = 1, limit = 10) => {
  const res = await apiClient.get(`/notifications/recent/${userId}?page=${page}&limit=${limit}`);
  return res.data;
};

export const markNotificationAsRead = async (id, userId) => {
  await apiClient.post(`/notifications/${id}/read`, { user_id: userId });
};
